var map = {
	"./schema_arrow_orange.png": "9b55",
	"./schema_circle_orange.png": "58ab",
	"./schema_eraser_orange.png": "100b",
	"./schema_line_orange.png": "cdcd",
	"./schema_palette_orange.png": "9bec",
	"./schema_pen_orange.png": "4fc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "992c";